import { useState, useEffect } from 'react';

export function UpdateNotification() {
  const [showUpdateNotification, setShowUpdateNotification] = useState(false);
  const [registration, setRegistration] = useState<ServiceWorkerRegistration | null>(null);

  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistration().then(reg => {
        if (reg) {
          setRegistration(reg);

          // Check if there's a waiting worker
          if (reg.waiting) {
            setShowUpdateNotification(true);
          }

          // Listen for new updates
          reg.addEventListener('updatefound', () => {
            const newWorker = reg.installing;
            if (newWorker) {
              newWorker.addEventListener('statechange', () => {
                if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                  setShowUpdateNotification(true);
                }
              });
            }
          });
        }
      });

      // Listen for controller change
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        // The service worker has taken control
        window.location.reload();
      });
    }
  }, []);

  const updateApp = () => {
    if (registration && registration.waiting) {
      // Send message to service worker to skip waiting
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      setShowUpdateNotification(false);
    }
  };

  if (!showUpdateNotification) {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 bg-[#2a2a45] text-white p-4 rounded-lg shadow-lg z-50 max-w-sm">
      <h3 className="font-medium mb-2">Update Available</h3>
      <p className="text-sm mb-3 opacity-90">A new version of DocuTalk is available. Update now for the latest features and improvements.</p>
      <div className="flex justify-end gap-2">
        <button
          className="px-3 py-1 text-sm border border-gray-600 rounded hover:bg-gray-700 transition-colors"
          onClick={() => setShowUpdateNotification(false)}
        >
          Later
        </button>
        <button
          className="px-3 py-1 text-sm bg-indigo-600 rounded hover:bg-indigo-700 transition-colors"
          onClick={updateApp}
        >
          Update Now
        </button>
      </div>
    </div>
  );
}
